import { CanMatchFn, Route, UrlSegment } from '@angular/router';
import { inject, Signal } from '@angular/core';
import { b2bWebMobileExperiment } from '../experiments/b2b-web-mobile.experiment';
import { IS_B2B } from '@lentau/profile/organizations/legal-entity/shared/tokens/is-b2b-profile.token';

export const canMatchB2bMobileCheckout: CanMatchFn = (_route: Route, segments: UrlSegment[]): boolean => {
  const isB2bWebMobile: Signal<boolean> = b2bWebMobileExperiment();
  const isB2B: Signal<boolean> = inject(IS_B2B);
  return isB2B() && isB2bWebMobile() && segments[0]?.path === 'ordering' && segments[1]?.path === 'interval';
};
